/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_TitleInputs */

const en_mk_studio_title = /** @type {(inputs: Mk_Studio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence you can bill a client for`)
};

const id_mk_studio_title = /** @type {(inputs: Mk_Studio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukti yang bisa ditagihkan ke klien`)
};

/**
* | output |
* | --- |
* | "Evidence you can bill a client for" |
*
* @param {Mk_Studio_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_title = /** @type {((inputs?: Mk_Studio_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_title(inputs)
	return en_mk_studio_title(inputs)
});